import { useEffect, useState } from 'react';
import ModalStateManager, { ModalState } from '../utils/ModalStateManager';

export function useModalState() {
  const manager = ModalStateManager.getInstance();
  const [state, setState] = useState<ModalState>(manager.getState());

  useEffect(() => {
    const unsubscribe = manager.subscribe(setState);
    return unsubscribe;
  }, []);

  return {
    modals: state,
    openModal: (modalName: keyof ModalState) => manager.openModal(modalName),
    closeModal: (modalName: keyof ModalState) => manager.closeModal(modalName),
    closeAllModals: () => manager.closeAllModals(),
    isModalOpen: (modalName: keyof ModalState) => manager.isModalOpen(modalName),
    hasOpenModals: () => manager.hasOpenModals()
  };
}